var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluationsBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.8H11.82C11.4 0.756 10.3 0 9 0C7.7 0 6.6 0.756 6.18 1.8H2C0.9 1.8 0 2.61 0 3.6V16.2C0 17.19 0.9 18 2 18H16C17.1 18 18 17.19 18 16.2V3.6C18 2.61 17.1 1.8 16 1.8ZM9 1.8C9.55 1.8 10 2.205 10 2.7C10 3.195 9.55 3.6 9 3.6C8.45 3.6 8 3.195 8 2.7C8 2.205 8.45 1.8 9 1.8ZM11 14.4H4V12.6H11V14.4ZM14 10.8H4V9H14V10.8ZM14 7.2H4V5.4H14V7.2Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationsBase);
export default __webpack_public_path__ + "static/media/evaluations_base.71e12bcc35fc8c2cd3a1aac51deaaa1d.svg";
export { ForwardRef as ReactComponent };